/* Prüne — comportamento da vitrine */
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const MOBILE = window.matchMedia('(max-width: 1023px)');
const safe = (fn) => { try { return fn(); } catch (e) { return null; } };

/* faixa de avisos: troca a cada 4 s */
$$('[data-pr-ribbon]').forEach((rb) => {
  const msgs = $$('.pr-ribbon__msg', rb);
  if (msgs.length < 2) return;
  let i = 0;
  setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4000);
});

/* pop-up da home */
$$('[data-pr-pop]').forEach((pop) => {
  if (safe(() => localStorage.getItem('pr-pop-never'))) return;
  const close = () => {
    pop.classList.remove('is-open');
    if (pop.querySelector('[data-pr-pop-never]')?.checked) safe(() => localStorage.setItem('pr-pop-never', '1'));
  };
  pop.querySelector('[data-pr-pop-close]')?.addEventListener('click', close);
  pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
  setTimeout(() => pop.classList.add('is-open'), 1200);
});

/* cabeçalho: fica branco ao rolar (home), some ao descer e volta ao subir */
const header = document.querySelector('[data-pr-header]');
if (header) {
  const wrapper = document.querySelector('.page-wrapper');
  const top = () => Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, wrapper ? wrapper.scrollTop : 0);
  let last = 0;
  const onScroll = () => {
    const y = top();
    header.classList.toggle('is-solid', y > 20);
    header.classList.toggle('is-hidden', y > last && y > 160);
    last = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  wrapper?.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* menu: gaveta com submenus que substituem a lista (botão voltar) */
const menu = document.querySelector('[data-pr-menu]');
if (menu) {
  const back = menu.querySelector('[data-pr-back]');
  const showMain = () => {
    menu.classList.remove('is-sub');
    $$('[data-pr-subpanel]', menu).forEach((p) => { p.hidden = true; });
    if (back) back.hidden = true;
  };
  const setOpen = (open) => {
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    document.querySelector('[data-pr-open-menu]')?.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('clone-lock', open && MOBILE.matches);
    if (!open) showMain();
  };
  $$('[data-pr-open-menu]').forEach((b) => b.addEventListener('click', () => setOpen(!menu.classList.contains('is-open'))));
  $$('[data-pr-close-menu]', menu).forEach((b) => b.addEventListener('click', () => setOpen(false)));
  back?.addEventListener('click', showMain);
  $$('[data-pr-sub]', menu).forEach((a) => a.addEventListener('click', (e) => {
    const panel = menu.querySelector(`[data-pr-subpanel="${a.dataset.prSub}"]`);
    if (!panel) return;
    e.preventDefault();
    showMain();
    panel.hidden = false;
    menu.classList.add('is-sub');
    if (back) back.hidden = false;
  }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  document.addEventListener('click', (e) => {
    if (menu.classList.contains('is-open') && !e.target.closest('.pr-menu__panel') && !e.target.closest('[data-pr-open-menu]')) setOpen(false);
  });
}

/* carrossel da home: troca a cada 6 s (sem pontos, como na referência) */
$$('[data-pr-hero]').forEach((hero) => {
  const track = hero.querySelector('.pr-hero__track');
  const slides = $$('.pr-hero__slide', track);
  if (slides.length < 2) return;
  let cur = 0;
  const go = (n) => {
    cur = (n + slides.length) % slides.length;
    window.cloneReveal?.(slides[cur]);
    track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };
  track.addEventListener('scroll', () => {
    const n = Math.round(track.scrollLeft / track.clientWidth);
    if (n !== cur) { cur = n; window.cloneReveal?.(slides[n]); }
  }, { passive: true });
  const timer = setInterval(() => go(cur + 1), 6000);
  hero.addEventListener('pointerdown', () => clearInterval(timer), { once: true });
});

/* prateleira de recomendados: setas */
$$('[data-pr-shelf]').forEach((shelf) => {
  const track = shelf.querySelector('.pr-shelf__track');
  const prev = shelf.querySelector('[data-pr-prev]');
  const next = shelf.querySelector('[data-pr-next]');
  if (!track || !prev || !next) return;
  const step = () => track.clientWidth + 4;
  const sync = () => {
    prev.disabled = track.scrollLeft < 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  };
  prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('scroll', sync, { passive: true });
  sync();
});

/* gavetas da direita: busca e conta */
const drawers = $$('[data-pr-drawer]');
const closeDrawers = () => drawers.forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
$$('[data-pr-open-drawer]').forEach((a) => a.addEventListener('click', (e) => {
  const d = document.querySelector(`[data-pr-drawer="${a.dataset.prOpenDrawer}"]`);
  if (!d) return;
  e.preventDefault();
  document.querySelector('[data-pr-menu]')?.classList.remove('is-open');
  closeDrawers();
  d.classList.add('is-open');
  d.setAttribute('aria-hidden', 'false');
  d.querySelector('input')?.focus({ preventScroll: true });
}));
$$('[data-pr-close-drawer]').forEach((b) => b.addEventListener('click', closeDrawers));
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });
document.addEventListener('click', (e) => {
  if (drawers.some((d) => d.classList.contains('is-open')) && !e.target.closest('.pr-drawer__panel') && !e.target.closest('[data-pr-open-drawer]')) closeDrawers();
});
$$('[data-pr-acc-go]').forEach((b) => b.addEventListener('click', () => {
  $$('[data-pr-acc]').forEach((p) => p.classList.toggle('is-active', p.dataset.prAcc === b.dataset.prAccGo));
}));

/* coleção: colunas, filtros em gaveta, ordenar, ver más */
const grid = document.querySelector('[data-pr-grid]');
$$('[data-pr-modes] .pr-mode').forEach((btn) => btn.addEventListener('click', () => {
  $$('[data-pr-modes] .pr-mode').forEach((b) => b.classList.toggle('is-on', b === btn));
  grid?.style.setProperty('--cols', MOBILE.matches ? btn.dataset.colsM : btn.dataset.colsD);
}));
const fd = document.querySelector('[data-pr-fdrawer]');
if (fd) {
  $$('[data-pr-open-filters]').forEach((b) => b.addEventListener('click', () => fd.classList.add('is-open')));
  $$('[data-pr-close-filters]', fd).forEach((b) => b.addEventListener('click', () => fd.classList.remove('is-open')));
}
$$('[data-pr-sort]').forEach((sel) => sel.addEventListener('change', () => {
  const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u;
}));
$$('[data-pr-filter-form]').forEach((f) => f.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox]')) f.submit(); }));
const more = document.querySelector('[data-pr-more]');
if (more) {
  more.addEventListener('click', async (e) => {
    e.preventDefault();
    more.setAttribute('aria-busy', 'true');
    try {
      const html = await (await fetch(more.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-pr-grid] > [data-pr-item]', doc).forEach((n) => grid.append(document.importNode(n, true)));
      const nm = doc.querySelector('[data-pr-more]');
      const seen = doc.querySelector('[data-pr-seen]');
      if (seen) {
        document.querySelector('[data-pr-seen]').textContent = seen.textContent;
        const bar = document.querySelector('[data-pr-bar]'); const nb = doc.querySelector('[data-pr-bar]');
        if (bar && nb) bar.style.width = nb.style.width;
      }
      if (nm) more.href = nm.href; else more.remove();
    } catch (err) { location.href = more.href; }
    more.removeAttribute('aria-busy');
  });
}
